import { render } from "./AppWebNameCol.vue?vue&type=template&id=50f08c16&scoped=true&ts=true&lang=pug"
import script from "./AppWebNameCol.vue?vue&type=script&lang=ts&setup=true"
export * from "./AppWebNameCol.vue?vue&type=script&lang=ts&setup=true"

import "./AppWebNameCol.vue?vue&type=style&index=0&id=50f08c16&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50f08c16"]])

export default __exports__